import moment from 'moment';

import {
	ATTACHMENT_CATEGORY_OTHER
} from '../../../models/guarantee-constants';
import { GuaranteeRequestAttachment } from '../../../models/guarantee-request-attachment';

const MAX_ATTACHMENT_SIZE_MB = 115;

export function buildAttachments(
	events: FileList | null,
	target: GuaranteeRequestAttachment[],
	sizeErrorMessage: string,
	creationBy: string
): string {
	if (!events) {
		return '';
	}
	let error = '';
	for (const file of Array.from(events)) {
		if (file.size / 1024 / 1024 > MAX_ATTACHMENT_SIZE_MB) {
			error = sizeErrorMessage;
			continue;
		}
		const attachment = new GuaranteeRequestAttachment();
		attachment.chronicleId = undefined;
		attachment.name = file.name;
		attachment.size = file.size;
		attachment.type = file.type;
		attachment.metaData.mimeType = file.type;
		attachment.metaData.type = ATTACHMENT_CATEGORY_OTHER;
		attachment.localUrl = URL.createObjectURL(file);
		attachment.creationDate = moment().toISOString();
		attachment.creationBy = creationBy;
		target.push(attachment);
	}
	return error;
}

export function formatAttachmentSize(bytes: number | undefined): string {
	if (bytes === undefined || bytes <= 0) {
		return '';
	}
	const kb = bytes / 1024;
	if (kb < 1024) {
		return `${ Math.round(kb) } KB`;
	}
	const mb = kb / 1024;
	return `${ mb.toFixed(mb < 10 ? 1 : 0) } MB`;
}
